var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ERW---Settings-Panel",
    transform: "translate(-1394.000000, -24.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PANEL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(1403.589831, 33.803970) rotate(45.000000) translate(-1403.589831, -33.803970) translate(1391.589831, 22.303970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.570121951,10.3429878 L22.570122,10.3429878 C22.8462643,10.3429878 23.070122,10.5668454 23.070122,10.8429878 L23.070122,12.1570122 C23.070122,12.4331546 22.8462643,12.6570122 22.570122,12.6570122 L0.570121951,12.6570122 C0.293979576,12.6570122 0.0701219512,12.4331546 0.0701219512,12.1570122 L0.0701219512,10.8429878 C0.0701219512,10.5668454 0.293979576,10.3429878 0.570121951,10.3429878 Z",
    id: "Rectangle-9",
    transform: "translate(11.570122, 11.500000) rotate(90.000000) translate(-11.570122, -11.500000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    x: 0,
    y: 10.35,
    width: 23.1402439,
    height: 2.3,
    rx: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.e5954121a80b3d26937a4efe34864b00.svg";
export { ForwardRef as ReactComponent };